(function (window, document) {
  const Utils = window.MVTUtils;

  const ASSIGNMENT = {
    /**
     * Decides which side of a test this visitor is on, and keeps that decision
     * stable across visits.
     *
     * Cookie consent changes the shape of this: when consent is required but not
     * yet granted, the assignment is still made so the page can render a variant,
     * but it is held in `__MVT_PENDING_ASSIGNMENT__` instead of being written to a
     * cookie. Nothing is persisted until consent arrives.
     *
     * ⚠️ The consequence is that a visitor who never grants consent is re-rolled on
     * every page load, so their behaviour is spread across both variants. That is
     * the deliberate trade — legal compliance over measurement — but it means
     * consent-heavy sites have noisier results than their traffic suggests.
     */
    assignUser: function (projectKey, cookiePrefix, cookieDays) {
      const fullCookieName = `${cookiePrefix}_${projectKey}`;
      const consentRequired = window.__MVT_CONSENT_REQUIRED__ === true;
      const consentGranted = window.__MVT_CONSENT_GRANTED__ === true;

      let assignedGroup = null;
      if (!consentRequired || consentGranted) {
        assignedGroup = Utils.getCookie(fullCookieName);
      }

      if (assignedGroup) {
        window.MVTAssignment = { projectKey: projectKey, group: assignedGroup };
        return assignedGroup;
      }

      assignedGroup = Math.random() < 0.5 ? "A" : "B";

      if (consentRequired && !consentGranted) {
        window.__MVT_PENDING_ASSIGNMENT__ = {
          fullCookieName: fullCookieName,
          assignedGroup: assignedGroup,
          cookieDays: cookieDays,
        };
      } else {
        Utils.setCookie(fullCookieName, assignedGroup, cookieDays);
      }

      window.MVTAssignment = {
        projectKey: projectKey,
        group: assignedGroup,
      };

      return assignedGroup;
    },

    flushPendingAssignment: function () {
      const pending = window.__MVT_PENDING_ASSIGNMENT__;
      if (pending && window.MVTUtils) {
        window.MVTUtils.setCookie(
          pending.fullCookieName,
          pending.assignedGroup,
          pending.cookieDays,
        );
        window.__MVT_PENDING_ASSIGNMENT__ = null;
      }
    },
  };

  window.MVTAssignmentModule = ASSIGNMENT;
})(window, document);
